export function playAudio(audioPath, selectedFiles, setAudioPlayer, setIsPlaying, getResourceUrl) {
  if (!audioPath) {
    alert("재생할 음원이 없습니다.");
    return;
  }
  let audioPlayer = null;
  setIsPlaying(false);
  // 선택된 오디오 파일이 있는 경우 로컬 파일 재생
  if (selectedFiles.audio) {
    const url = URL.createObjectURL(selectedFiles.audio);
    audioPlayer = new Audio(url);
  } else {
    audioPlayer = new Audio(getResourceUrl(audioPath));
  }
  audioPlayer.addEventListener("ended", () => {
    setIsPlaying(false);
  });
  audioPlayer.play();
  setAudioPlayer(audioPlayer);
  setIsPlaying(true);
}

export function stopAudio(audioPlayer, setAudioPlayer, setIsPlaying) {
  if (audioPlayer) {
    audioPlayer.pause();
    setAudioPlayer(null);
    setIsPlaying(false);
  }
} 